export const DEFAULT_NEXT_ICON = 'arrow-right';
